import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createDeepSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { CotizacionComponent } from "./component";
import { VerCotizacion } from "./ver/component";
import * as globals from "app/resources/globals";


interface Props {
    value: models.CotizadorModel;
    onChange: (x: models.CotizadorModel) => void;
    session: models.Session
}

const JsonRx = componentToRx(kea.Json);
/**
* Componente para editar un 
*/
class CotizadorControlledNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    cotizacion = createDeepSelectorRx(this.value, async (value) => {
        //Si el usuario ya lleno los valores 
        const valoresAsignados = !!(value.IdColoniaDestino && value.IdColoniaOrigen);
        if (!valoresAsignados) {
            return undefined;
        }
        const ret = await resources.Cotizador.Cotizar(value);
        return ret;
    });

    render() {
        const { value } = this.props;
        const cotizacion = this.cotizacion(this.props);
        return (
            <div>
                <CotizacionComponent {...this.props} />
                <VerCotizacion value={cotizacion} />
            </div>);
    }
}

const CotizadorController = componentToRx(CotizadorControlledNoRx);
export const Cotizador = kea.defaultProps(CotizadorController, {
    value: globals.state.map(x => x.cotizacion),
    onChange: x => globals.setState({ cotizacion: x })
});


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cotizador/index.tsx